/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CreatePartnerApplicationRequest } from '../model';
/**
 * PartnerApplicationControllerApi - axios parameter creator
 * @export
 */
export const PartnerApplicationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreatePartnerApplicationRequest} request 
         * @param {File} bankInformationFile 
         * @param {File} companyRegistryFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOnboarding: async (request: CreatePartnerApplicationRequest, bankInformationFile: File, companyRegistryFile: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('createOnboarding', 'request', request)
            // verify required parameter 'bankInformationFile' is not null or undefined
            assertParamExists('createOnboarding', 'bankInformationFile', bankInformationFile)
            // verify required parameter 'companyRegistryFile' is not null or undefined
            assertParamExists('createOnboarding', 'companyRegistryFile', companyRegistryFile)
            const localVarPath = `/partners/applications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (request !== undefined) { 
                localVarFormParams.append('request', new Blob([JSON.stringify(request)], { type: "application/json", }));
            }
    
            if (bankInformationFile !== undefined) { 
                localVarFormParams.append('bankInformationFile', bankInformationFile as any);
            }
    
            if (companyRegistryFile !== undefined) { 
                localVarFormParams.append('companyRegistryFile', companyRegistryFile as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PartnerApplicationControllerApi - functional programming interface
 * @export
 */
export const PartnerApplicationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PartnerApplicationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreatePartnerApplicationRequest} request 
         * @param {File} bankInformationFile 
         * @param {File} companyRegistryFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOnboarding(request: CreatePartnerApplicationRequest, bankInformationFile: File, companyRegistryFile: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOnboarding(request, bankInformationFile, companyRegistryFile, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PartnerApplicationControllerApi - factory interface
 * @export
 */
export const PartnerApplicationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PartnerApplicationControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {CreatePartnerApplicationRequest} request 
         * @param {File} bankInformationFile 
         * @param {File} companyRegistryFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOnboarding(request: CreatePartnerApplicationRequest, bankInformationFile: File, companyRegistryFile: File, options?: any): AxiosPromise<void> {
            return localVarFp.createOnboarding(request, bankInformationFile, companyRegistryFile, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PartnerApplicationControllerApi - object-oriented interface
 * @export
 * @class PartnerApplicationControllerApi
 * @extends {BaseAPI}
 */
export class PartnerApplicationControllerApi extends BaseAPI {
    /**
     * 
     * @param {CreatePartnerApplicationRequest} request 
     * @param {File} bankInformationFile 
     * @param {File} companyRegistryFile 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApplicationControllerApi
     */
    public createOnboarding(request: CreatePartnerApplicationRequest, bankInformationFile: File, companyRegistryFile: File, options?: AxiosRequestConfig) {
        return PartnerApplicationControllerApiFp(this.configuration).createOnboarding(request, bankInformationFile, companyRegistryFile, options).then((request) => request(this.axios, this.basePath));
    }
}

